import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Links";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/links")({
  head: () => pageHead({ title: "Clara Camille | Links", path: "/links", noindex: true }),
  component: Page,
});
